export const LOADING_TIMESHEET = "LOADING_TIMESHEET";
export const GET_TIMESHEET_LIST = "GET_TIMESHEET_LIST";
export const GET_TIMESHEET_ID = "GET_TIMESHEET_ID";
export const REMOVE_TIMESHEET = "REMOVE_TIMESHEET";
export const ADD_TIMESHEET = "ADD_TIMESHEET";
export const UPDATE_TIMESHEET = "UPDATE_TIMESHEET";
export const GET_TIMESHEET_BY_STATUS = "GET_TIMESHEET_BY_STATUS";
export const TIMESHEET_APPROVAL = "TIMESHEET_APPROVAL";
